<form novalidate (ngSubmit)="goNext()" [formGroup]="employmentInfoForm" [ngClass]='{"h-100": !isBuyNow && !isLegacyCreditApp}'>
  <div class="row m-0 credit-app-body"  [ngClass]='{"noshadow employment-info-buynow": isBuyNow || isLegacyCreditApp, "employment-info pl-4 pr-4": !isBuyNow && !isLegacyCreditApp}'>
    <div class="col-12  scrollDiv">
      <div class="row m-0">
        <div class="col-12 col-md-6 col-xl-4  px-0 pr-md-2 order-1" [ngClass]="{'bn-empl-wide': isBuyNow || isLegacyCreditApp }" >
          <label for="employment_status">{{ employmentInfoConfigData?.EmploymentStatusLabel }}</label>
          <select id="employment_status" class="form-control gradient" formControlName="EmploymentStatus" [ngClass]="{'error': !employmentInfoForm.get('EmploymentStatus').valid &&
                                          (formSubmitAttempt ||
                                            (employmentInfoForm.get('EmploymentStatus').touched
                                                || employmentInfoForm.get('EmploymentStatus').dirty))}">
            <option value="" [selected]="employmentInfoForm.get('EmploymentStatus').value === ''">
              {{ creditAppConfigData?.SelectsDefaultLabel }}
            </option>
            <option *ngFor="let employmentStatusType of employmentStatusTypes" [value]="employmentStatusType.Value"
                    [selected]="employmentStatusType.Value === employmentInfoForm.get('EmploymentStatus').value">
              {{ employmentStatusType?.Description }}
            </option>
          </select>
          <div class="form-validator_error">
            <span class="invalid-feedback d-block" *ngIf="!employmentInfoForm.get('EmploymentStatus').valid &&
                              (formSubmitAttempt ||
                                (employmentInfoForm.get('EmploymentStatus').touched
                                  || employmentInfoForm.get('EmploymentStatus').dirty))">
              <ng-container *ngIf="!!employmentInfoForm.get('EmploymentStatus').errors?.required">
                {{ employmentInfoConfigData?.EmploymentStatusRequired }}
              </ng-container>
            </span>
          </div>
        </div>
        <div class="col-12 col-md-6 px-0  col-xl-4  pl-md-2 order-2" *ngIf="!isCustomerRetired" [ngClass]="{'bn-empl-wide': isBuyNow || isLegacyCreditApp }">
          <label for="employment_type">{{ employmentInfoConfigData?.EmploymentTypeLabel }}</label>
          <select id="employment_type" class="form-control  gradient" formControlName="EmploymentType" [ngClass]="{'error': !employmentInfoForm.get('EmploymentType').valid &&
                                          (formSubmitAttempt
                                            || (employmentInfoForm.get('EmploymentType').touched
                                              || employmentInfoForm.get('EmploymentType').dirty))}">
            <option value="" [selected]="employmentInfoForm.get('EmploymentType').value === ''">
              {{ creditAppConfigData?.SelectsDefaultLabel }}
            </option>
            <option *ngFor="let employmentType of employmentTypes" [value]="employmentType.Value"
                    [selected]="employmentType.Value === employmentInfoForm.get('EmploymentType').value">
              {{ employmentType?.Description }}
            </option>
          </select>
          <div class="form-validator_error">
            <span class="invalid-feedback d-block" *ngIf="!employmentInfoForm.get('EmploymentType').valid &&
                            (formSubmitAttempt ||
                              (employmentInfoForm.get('EmploymentType').touched
                                || employmentInfoForm.get('EmploymentType').dirty))">
              <ng-container *ngIf="!!employmentInfoForm.get('EmploymentType').errors?.required">
                {{ employmentInfoConfigData?.EmploymentTypeRequired }}
              </ng-container>
            </span>
          </div>
        </div>
        <div formGroupName="RetiredDurationGroup" class="col-12 col-lg-6 px-0 order-7 " *ngIf="isCustomerRetired" [ngClass]='{"group-padding": !isBuyNow && !isLegacyCreditApp}'>
          <div class="row m-0 p-0">
            <div class="{{isLegacyCreditApp && isMobile() ? 'col-12' : 'col-6'}} col-md-5 col-lg-6 px-0 pr-md-2 {{isLegacyCreditApp && isMobile() ? 'pr-sm-0' : 'pr-sm-7'}}" [ngClass]="{'bn-empl-others': isBuyNow || isLegacyCreditApp}">
              <label class="d-block">Total Years Retired</label>
              <select class="form-control w-100 w-sm-100 gradient" formControlName="TotalYearsRetired"
                      [ngClass]="{'error': employmentInfoForm.get('RetiredDurationGroup').errors ||
                                                (!employmentInfoForm.get('RetiredDurationGroup.TotalYearsRetired').valid &&
                                                  (formSubmitAttempt || (employmentInfoForm.get('RetiredDurationGroup.TotalYearsRetired').touched
                                                    || employmentInfoForm.get('RetiredDurationGroup.TotalYearsRetired').dirty)))}">
                <option value="" [selected]="employmentInfoForm.get('RetiredDurationGroup.TotalYearsRetired').value === ''
                                                            || employmentInfoForm.get('RetiredDurationGroup.TotalYearsRetired').value === null">
                  {{ creditAppConfigData?.SelectsDefaultLabel }}
                </option>
                <option *ngFor="let yearOnJobType of yearsOnJobType" [value]="yearOnJobType.Value"
                        [selected]="yearOnJobType.Value === employmentInfoForm.get('RetiredDurationGroup.TotalYearsRetired').value">
                  {{ yearOnJobType?.Description }}
                </option>
              </select>
              <div class="form-validator_error">
                <span class="invalid-feedback d-block" *ngIf="employmentInfoForm.get('RetiredDurationGroup').errors ||
                                                (!employmentInfoForm.get('RetiredDurationGroup.TotalYearsRetired').valid &&
                                                (formSubmitAttempt ||
                                                  (employmentInfoForm.get('RetiredDurationGroup.TotalYearsRetired').touched
                                                    || employmentInfoForm.get('RetiredDurationGroup.TotalYearsRetired').dirty)))">
                  <ng-container *ngIf="!!employmentInfoForm.get('RetiredDurationGroup.TotalYearsRetired').errors?.required; else secondRetired">
                    Total Years Retired is required
                  </ng-container>
                  <ng-template #secondRetired>
                    <ng-container *ngIf="!!employmentInfoForm.get('RetiredDurationGroup').errors?.invalidselection">
                      {{ employmentInfoConfigData?.TotalYrsZeroValidation }}
                    </ng-container>
                  </ng-template>
                </span>
              </div>
            </div>
            <div class="{{isLegacyCreditApp && isMobile() ? 'col-12' : 'col-6'}} col-md-5 col-lg-6 px-0 pl-md-2 {{isLegacyCreditApp && isMobile() ? 'pl-sm-0' : 'pl-sm-7'}}" [ngClass]="{'bn-empl-others': isBuyNow || isLegacyCreditApp}">
              <label for="total_months_retired" class="d-block">Total Months Retired</label>
              <select id="total_months_retired" class="form-control w-100 w-sm-100 gradient" formControlName="TotalMonthsRetired" [ngClass]="{'error': employmentInfoForm.get('RetiredDurationGroup').errors ||
                                                            (!employmentInfoForm.get('RetiredDurationGroup.TotalMonthsRetired').valid &&
                                                            (formSubmitAttempt || (employmentInfoForm.get('RetiredDurationGroup.TotalMonthsRetired').touched
                                                              || employmentInfoForm.get('RetiredDurationGroup.TotalMonthsRetired').dirty)))}">
                <option value="" [selected]="employmentInfoForm.get('RetiredDurationGroup.TotalMonthsRetired').value === ''
                                                            || employmentInfoForm.get('RetiredDurationGroup.TotalMonthsRetired').value === null">
                  {{ creditAppConfigData?.SelectsDefaultLabel }}
                </option>
                <option *ngFor="let monthOnJobType of monthsOnJobType" [value]="monthOnJobType.Value"
                        [selected]="monthOnJobType.Value === employmentInfoForm.get('RetiredDurationGroup.TotalMonthsRetired').value">
                  {{ monthOnJobType?.Description }}
                </option>
              </select>
              <div class="form-validator_error">
                <span class="invalid-feedback d-block" *ngIf="employmentInfoForm.get('RetiredDurationGroup').errors ||
                                                (!employmentInfoForm.get('RetiredDurationGroup.TotalMonthsRetired').valid &&
                                                (formSubmitAttempt || (employmentInfoForm.get('RetiredDurationGroup.TotalMonthsRetired').touched
                                                  || employmentInfoForm.get('RetiredDurationGroup.TotalMonthsRetired').dirty)))">
                  <ng-container *ngIf="!!employmentInfoForm.get('RetiredDurationGroup.TotalMonthsRetired').errors?.required; else second">
                    Total Months Retired is required
                  </ng-container>
                  <ng-template #second>
                    <ng-container *ngIf="!!employmentInfoForm.get('RetiredDurationGroup').errors?.invalidselection">
                      {{ employmentInfoConfigData?.TotalMnthsZeroValidation }}
                    </ng-container>
                  </ng-template>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="break col-12 order-3"></div>
        <div class="col-12 col-md-6 col-xl-4 px-0 pr-md-2 order-3" *ngIf="!isCustomerRetired" [ngClass]="{'bn-empl-wide emp-name': isBuyNow || isLegacyCreditApp }">
          <label for="employer_name">{{ employmentInfoConfigData?.EmployerNameLabel }}</label>
          <input id="employer_name" class="form-control   pr-5" type="text" maxlength="25" formControlName="EmployerName" [ngClass]="{'error': !employmentInfoForm.get('EmployerName').valid &&
                                        (employmentInfoForm.get('EmployerName').touched ||
                                          employmentInfoForm.get('EmployerName').dirty ||
                                          (formSubmitAttempt && !employerNameCleared))}" />
          <span role="button" class="form-error-x dt-icon dt-icon-input-clear mt-4 error-x error-x" *ngIf="!employmentInfoForm.get('EmployerName').valid &&
                    (employmentInfoForm.get('EmployerName').touched ||
                      employmentInfoForm.get('EmployerName').dirty ||
                      (formSubmitAttempt && !employerNameCleared))"
                (click)="clearValidations(employmentInfoForm.get('EmployerName'))" aria-label="Clear employer name"
                (keyup)="$event?.keyCode ===  13 ? clearValidations(employmentInfoForm.get('EmployerName')) : null">

          </span>
          <div class="form-validator_error">
            <span class="invalid-feedback d-block" *ngIf="!employmentInfoForm.get('EmployerName').valid &&
                          (employmentInfoForm.get('EmployerName').touched ||
                            employmentInfoForm.get('EmployerName').dirty ||
                            (formSubmitAttempt && !employerNameCleared))">
              <ng-container *ngIf="!!employmentInfoForm.get('EmployerName').errors?.required; else second">
                {{ employmentInfoConfigData?.EmployerNameRequired }}
              </ng-container>
              <ng-template #second>
                <ng-container *ngIf="!!employmentInfoForm.get('EmployerName').errors?.pattern">
                  {{employmentInfoConfigData?.EmployerNameInvalid}}
                </ng-container>
              </ng-template>
            </span>
          </div>
        </div>
        <div class="col-12 col-md-6  col-xl-4 px-0 pl-md-2 order-4" *ngIf="!isCustomerRetired" [ngClass]="{'bn-empl-wide': isBuyNow || isLegacyCreditApp }">
          <label for="job_title">{{ employmentInfoConfigData?.JobTitleLabel }}</label>
          <input id="job_title" class="form-control  pr-5" type="text" maxlength="20" formControlName="JobTitle" [ngClass]="{'error': !employmentInfoForm.get('JobTitle').valid &&
                                        (employmentInfoForm.get('JobTitle').touched ||
                                          employmentInfoForm.get('JobTitle').dirty ||
                                          (formSubmitAttempt && !jobTitleCleared))}" />
          <span role="button" class="form-error-x dt-icon dt-icon-input-clear mt-4 error-x" *ngIf="!employmentInfoForm.get('JobTitle').valid &&
                        (employmentInfoForm.get('JobTitle').touched ||
                          employmentInfoForm.get('JobTitle').dirty ||
                          (formSubmitAttempt && !jobTitleCleared))"
                (click)="clearValidations(employmentInfoForm.get('JobTitle'))" aria-label="Clear job title"
                (keyup)="$event?.keyCode ===  13 ? clearValidations(employmentInfoForm.get('JobTitle')) : null">

          </span>
          <div class="form-validator_error">
            <span class="invalid-feedback d-block" *ngIf="!employmentInfoForm.get('JobTitle').valid &&
                      (employmentInfoForm.get('JobTitle').touched ||
                        employmentInfoForm.get('JobTitle').dirty ||
                        (formSubmitAttempt && !jobTitleCleared))">
              <ng-container *ngIf="!!employmentInfoForm.get('JobTitle').errors?.required; else second">
                {{ employmentInfoConfigData?.JobTitleRequired }}
              </ng-container>
              <ng-template #second>
                <ng-container *ngIf="!!employmentInfoForm.get('JobTitle').errors?.pattern">
                  {{employmentInfoConfigData?.JobTitleInvalid}}
                </ng-container>
              </ng-template>
            </span>
          </div>
        </div>
        <div class="break col-12 order-5"></div>

        <div class="col-12 col-lg-3 px-0 pr-md-2 order-5" *ngIf="!isCustomerRetired" [ngClass]="{'col-md-6 bn-empl-phone-wide emp-phone': isBuyNow || isLegacyCreditApp, 'col-md-5': !isBuyNow && !isLegacyCreditApp }">
          <label for="employer_phone">{{ employmentInfoConfigData?.EmployerPhoneNumberLabel }}</label>
          <input id="employer_phone" class="form-control w-100 pr-6" type="text" formControlName="EmployerPhone"
                 [dtTextMask]="{ mask: phoneMask, guide:true }" placeholder="(___)___-____" [ngClass]="{'error': !employmentInfoForm.get('EmployerPhone').valid &&
                                        (employmentInfoForm.get('EmployerPhone').touched ||
                                          employmentInfoForm.get('EmployerPhone').dirty ||
                                          (formSubmitAttempt && !employerPhoneCleared)) }" />
          <span role="button" class="form-error-x dt-icon dt-icon-input-clear mt-4 error-x" *ngIf="!employmentInfoForm.get('EmployerPhone').valid &&
                    (employmentInfoForm.get('EmployerPhone').touched ||
                      employmentInfoForm.get('EmployerPhone').dirty ||
                      (formSubmitAttempt && !employerPhoneCleared))"
                (click)="clearValidations(employmentInfoForm.get('EmployerPhone'))" aria-label="Clear employer phone"
                (keyup)="$event?.keyCode ===  13 ? clearValidations(employmentInfoForm.get('EmployerPhone')) : null">

          </span>
          <div class="form-validator_error">
            <span class="invalid-feedback d-block" *ngIf="!employmentInfoForm.get('EmployerPhone').valid &&
                      (employmentInfoForm.get('EmployerPhone').touched ||
                        employmentInfoForm.get('EmployerPhone').dirty ||
                        (formSubmitAttempt && !employerPhoneCleared))">
              <ng-container *ngIf="!!employmentInfoForm.get('EmployerPhone').errors?.required; else second">
                {{ employmentInfoConfigData?.EmployerPhoneNumberRequired }}
              </ng-container>
              <ng-template #second>
                <ng-container
                   *ngIf="!employmentInfoForm.get('EmployerPhone').valid"
                  >
                  {{ employmentInfoConfigData?.EmployerPhoneNumberInvalid }}
                </ng-container>
              </ng-template>
            </span>
          </div>
        </div>
        <div class="d-none d-md-block d-lg-none col-md-7 order-6" *ngIf="!isCustomerRetired">

        </div>
        <div formGroupName="EmployerDurationGroup" class="col-12 col-lg-8 px-0 pl-lg-2 order-7" *ngIf="!isCustomerRetired" [ngClass]='{"group-padding": !isBuyNow && !isLegacyCreditApp }'>
          <div class="row m-0 p-0">
            <div class="{{isLegacyCreditApp && isMobile() ? 'col-12' : 'col-6'}} col-lg-6 col-xl-6 px-0 pr-md-2 {{isLegacyCreditApp && isMobile() ? 'pr-sm-0' : 'pr-sm-7'}}" [ngClass]="{'col-md-6 bn-empl-others': isBuyNow || isLegacyCreditApp, 'col-md-5': !isBuyNow && !isLegacyCreditApp}">
              <label for="total_years" class="d-block">{{ employmentInfoConfigData?.TotalYearsAtJobLabel }}</label>
              <select id="total_years" class="form-control w-100 w-sm-100 gradient" formControlName="TotalYears"
                      [ngClass]="{'error': employmentInfoForm.get('EmployerDurationGroup').errors ||
                  (!employmentInfoForm.get('EmployerDurationGroup.TotalYears').valid &&
                                          (formSubmitAttempt ||
                                            (employmentInfoForm.get('EmployerDurationGroup.TotalYears').touched
                                              || employmentInfoForm.get('EmployerDurationGroup.TotalYears').dirty)))}">
                <option value=""
                        [selected]="employmentInfoForm.get('EmployerDurationGroup.TotalYears').value === ''
                                          || employmentInfoForm.get('EmployerDurationGroup.TotalYears').value === null">
                  {{ creditAppConfigData?.SelectsDefaultLabel }}
                </option>
                <option *ngFor="let yearOnJobType of yearsOnJobType" [value]="yearOnJobType.Value"
                        [selected]="yearOnJobType.Value === employmentInfoForm.get('EmployerDurationGroup.TotalYears').value">
                  {{ yearOnJobType?.Description }}
                </option>
              </select>
              <div class="form-validator_error">
                <span class="invalid-feedback d-block" *ngIf="employmentInfoForm.get('EmployerDurationGroup').errors ||
                    (!employmentInfoForm.get('EmployerDurationGroup.TotalYears').valid &&
                              (formSubmitAttempt ||
                                (employmentInfoForm.get('EmployerDurationGroup.TotalYears').touched
                                  || employmentInfoForm.get('EmployerDurationGroup.TotalYears').dirty)))">
                  <ng-container *ngIf="!!employmentInfoForm.get('EmployerDurationGroup.TotalYears').errors?.required; else second">
                    {{ employmentInfoConfigData?.TotalYearsAtJobRequired }}
                  </ng-container>
                  <ng-template #second>
                    <ng-container *ngIf="!!employmentInfoForm.get('EmployerDurationGroup').errors?.invalidselection">
                      {{ employmentInfoConfigData?.TotalYrsZeroValidation }}
                    </ng-container>
                  </ng-template>
                </span>
              </div>
            </div>
            <div class="{{isLegacyCreditApp && isMobile() ? 'col-12' : 'col-6'}} col-lg-6 col-xl-6 px-0 pl-md-2 {{isLegacyCreditApp && isMobile() ? 'pl-sm-0' : 'pl-sm-7'}}" [ngClass]="{'col-md-6 bn-empl-others': isBuyNow || isLegacyCreditApp, 'col-md-5': !isBuyNow && !isLegacyCreditApp }">
              <label for="total_months" class="d-block">{{ employmentInfoConfigData?.TotalMonthsAtJobLabel }}</label>
              <select id="total_months" class="form-control w-100 w-sm-100 gradient" formControlName="TotalMonths" [ngClass]="{'error': employmentInfoForm.get('EmployerDurationGroup').errors ||
                                        (!employmentInfoForm.get('EmployerDurationGroup.TotalMonths').valid &&
                                        (formSubmitAttempt || (employmentInfoForm.get('EmployerDurationGroup.TotalMonths').touched
                                          || employmentInfoForm.get('EmployerDurationGroup.TotalMonths').dirty)))}">
                <option value="" [selected]="employmentInfoForm.get('EmployerDurationGroup.TotalMonths').value === ''
                                          || employmentInfoForm.get('EmployerDurationGroup.TotalMonths').value === null">
                  {{ creditAppConfigData?.SelectsDefaultLabel }}
                </option>
                <option *ngFor="let monthOnJobType of monthsOnJobType" [value]="monthOnJobType.Value"
                        [selected]="monthOnJobType.Value === employmentInfoForm.get('EmployerDurationGroup.TotalMonths').value">
                  {{ monthOnJobType?.Description }}
                </option>
              </select>
              <div class="form-validator_error">
                <span class="invalid-feedback d-block" *ngIf=" employmentInfoForm.get('EmployerDurationGroup').errors ||
                  (!employmentInfoForm.get('EmployerDurationGroup.TotalMonths').valid &&
                            (formSubmitAttempt || (employmentInfoForm.get('EmployerDurationGroup.TotalMonths').touched
                              || employmentInfoForm.get('EmployerDurationGroup.TotalMonths').dirty)))">
                  <ng-container *ngIf="!!employmentInfoForm.get('EmployerDurationGroup.TotalMonths').errors?.required; else second">
                    {{ employmentInfoConfigData?.TotalMonthsAtJobRequired }}
                  </ng-container>
                  <ng-template #second>
                    <ng-container *ngIf="!!employmentInfoForm.get('EmployerDurationGroup').errors?.invalidselection">
                      {{ employmentInfoConfigData?.TotalMnthsZeroValidation }}
                    </ng-container>
                  </ng-template>
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="d-none d-lg-block col-lg-3 order-8" *ngIf="!isCustomerRetired">

        </div>
        <div class="break col-12 order-9"></div>
        <div class="{{isLegacyCreditApp && isMobile() ? 'col-12' : 'col-6'}} col-lg-3 px-0 pr-md-2 {{isLegacyCreditApp && isMobile() ? 'pr-sm-0' : 'pr-sm-7'}} order-9" [ngClass]="{'col-md-6 bn-empl-others': isBuyNow || isLegacyCreditApp, 'col-md-5': !isBuyNow && !isLegacyCreditApp }">
          <label for="gross_salary" class="d-block">{{ employmentInfoConfigData?.GrossSalaryLabel }}</label>
          <div class="dollar-symbol w-sm-100">
            <input id="gross_salary"
                   class="form-control w-100"
                   type="text"
                   formControlName="GrossSalary"
                   [dtTextMask]="{ mask: numberMask, guide:false }" [ngClass]="{'error': !employmentInfoForm.get('GrossSalary').valid &&
                                                (employmentInfoForm.get('GrossSalary').touched ||
                                                  employmentInfoForm.get('GrossSalary').dirty ||
                                                  (formSubmitAttempt && !grossSalaryCleared)),
                                                  'pl-5 pr-5': !isMobile() }"
                   maxlength="7" />
          </div>
          <span role="button" class="form-error-x dt-icon dt-icon-input-clear mt-4 gross-salary-error-x error-x" *ngIf="!employmentInfoForm.get('GrossSalary').valid &&
                          (employmentInfoForm.get('GrossSalary').touched ||
                            employmentInfoForm.get('GrossSalary').dirty ||
                            (formSubmitAttempt && !grossSalaryCleared))"
                (click)="clearValidations(employmentInfoForm.get('GrossSalary'))" aria-label="Clear gross salary"
                (keyup)="$event?.keyCode ===  13 ? clearValidations(employmentInfoForm.get('GrossSalary')) : null">

          </span>
          <div class="form-validator_error">
            <span class="invalid-feedback d-block" *ngIf="!employmentInfoForm.get('GrossSalary').valid &&
                                (employmentInfoForm.get('GrossSalary').touched ||
                                  employmentInfoForm.get('GrossSalary').dirty ||
                                  (formSubmitAttempt && !grossSalaryCleared))">
              <ng-container *ngIf="!!employmentInfoForm.get('GrossSalary').errors?.required">
                {{ employmentInfoConfigData?.GrossSalaryRequired }}
              </ng-container>
            </span>
          </div>
        </div>
    <!--<div class="col-6 col-lg-3 px-0 pl-md-2 pl-sm-7 order-10" [ngClass]="{'col-md-6 bn-empl-others': isBuyNow, 'col-md-5': !isBuyNow }">
    <label class="d-block">{{ employmentInfoConfigData?.IncomeFrequencyLabel }}</label>
    <select id="income_frequency" class="form-control w-100 w-sm-100 gradient" formControlName="IncomeFrequency" [ngClass]="{'error': !employmentInfoForm.get('IncomeFrequency').valid &&
                                          (formSubmitAttempt || (employmentInfoForm.get('IncomeFrequency').touched
                                                                || employmentInfoForm.get('IncomeFrequency').dirty))
                                            }">
      <option value="" [selected]="employmentInfoForm.get('IncomeFrequency').value === ''">
        {{ creditAppConfigData?.SelectsDefaultLabel }}
      </option>
      <option *ngFor="let incomePeriodInterval of incomePeriodIntervalType" [value]="incomePeriodInterval.Value"
        [selected]="incomePeriodInterval.Value === employmentInfoForm.get('IncomeFrequency').value">
        {{ incomePeriodInterval?.Description }}
      </option>
    </select>
    <div class="form-validator_error">
      <span class="invalid-feedback d-block"
        *ngIf="!employmentInfoForm.get('IncomeFrequency').valid &&
                                          (formSubmitAttempt || (employmentInfoForm.get('IncomeFrequency').touched
                                                                || employmentInfoForm.get('IncomeFrequency').dirty))">
         <ng-container *ngIf="!!employmentInfoForm.get('IncomeFrequency').errors?.required">
          {{ employmentInfoConfigData?.IncomeFrequencyRequired }}
          </ng-container>
         </span>
       </div>
     </div>-->

      </div>
      </div>
    </div>
  </form>



  <div class="credit-app-cta-section">
    <div class="row m-0 w-100 cta-section">
      <div class="col-12 p-0 d-flex cta-col cta-alignment m-0">
        <button
          id="back_cta"
          type="button"
          class="secondary-cta mr-auto"
          [disabled]="isSaving"
          (click)="goBack()"
        >
          {{  employmentInfoConfigData?.BackCta  }}
        </button>
        <button
          id="next_cta"
          class="primary-cta ml-auto"
          [disabled]="!employmentInfoForm.valid || isSaving"
          (click)="goNext()"
        >
          {{employmentInfoConfigData?.NextCta }}
        </button>
      </div>
    </div>
  </div>
